<template>
  <router-view :key="$route.fullPath"></router-view>
</template>

<script>
import constants from './constants'
import { mapGetters } from 'vuex'
export default {
  name: "app",
  computed: {
    ...mapGetters(
      { 'user': 'user/user' }
    )
  },
  sockets: {
    connect(){
    },
    sendAlert(alert){
      // Notificacion sólo para solicitantes y cuya empresa corresponda al cliente que se indica la alerta
      if(this.user.role.code === constants.SOLICITANTE && this.user.company_id === alert.company_id){
        this.$toastr.info(
          alert.comments,
          "Alerta",
          { positionClass: "toast-top-center", closeButton: true }
        );
      }
    }
  }
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";
/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";
/* Import Flag Icons Set */
@import "~flag-icon-css/css/flag-icon.min.css";
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
// Import Main styles for this application
@import "assets/scss/style";
</style>
